import React, {useEffect} from "react";
import Home from './templates/Home'
import Contact from './templates/Contact'
import PortfolioPage from "./templates/PortfolioDetail";
import PrivacyPolicyPage from "./templates/PrivacyPolicy";
// import PortfolioPage from "./templates/Portfolio";
import TeamPage from "./templates/Team";
import TeamBioPage from "./templates/TeamBio";
import PageLayout from './components';
import {Route, Routes} from 'react-router-dom';
import "./App.css";
import InsightsPage from "./templates/Insights";
import InsightDetailPage from "./templates/InsightDetail";

import ScrollToTop from './scrollToTop';
import PodcastsPage from "./templates/Podcasts";
import _ from "lodash";
import {TEAM_DATA} from "./constants/newTeamData";
import PodcastsDetailPage from './templates/PodcastsDetail';
import {useResetRecoilState} from "recoil";
import {companiesState, homeState, teamState} from "./states";

const App = () => {
    const teamsSlug = _.uniqBy(_.flattenDeep(TEAM_DATA.map((item) => item.teams)), 'name');
    const resetCompanies = useResetRecoilState(companiesState);
    const resetTeam = useResetRecoilState(teamState);
    const resetHome = useResetRecoilState(homeState);

    useEffect(() => {
        resetCompanies()
        resetTeam()
        resetHome()
    }, [])

    return (
        <div className="App">
            <PageLayout>
                <ScrollToTop/>
                <Routes>
                    <Route exact path='/' element={<Home/>}/>
                    <Route exact path='/contact' element={<Contact/>}/>
                    <Route exact path='/privacy-policy' element={<PrivacyPolicyPage/>}/>
                    <Route exact path='/companies' element={<PortfolioPage/>}/>
                    {teamsSlug.map((item, key) => (
                        <Route
                            exact
                            key={key}
                            path={`/teammember/${item.slug}`}
                            element={<TeamPage slug={item.slug}/>}
                        />
                    ))}
                    <Route exact path="/companies/:slug" element={<PortfolioPage/>}/>
                    <Route exact path="/team" element={<TeamPage/>}/>
                    <Route exact path="/teammember/:slug" element={<TeamBioPage/>}/>
                    <Route exact path="/teammember/:slug/:portfolioSlug" element={<TeamBioPage/>}/>
                    <Route exact path="/teammember/:slug/page/:pageCount" element={<TeamBioPage/>}/>
                    <Route exact path="/insights" element={<InsightsPage/>}/>
                    <Route exact path="/insights/page/:pageCount" element={<InsightsPage/>}/>
                    <Route exact path="/insights/:slug" element={<InsightDetailPage/>}/>
                    <Route exact path="/contact" element={<Contact/>}/>
                    <Route exact path="/podcasts" element={<PodcastsPage/>}/>
                    <Route exact path="/podcasts/running-through-walls" element={<PodcastsPage/>}/>
                    <Route exact path="/podcasts/running-through-walls/page/:pageCount" element={<PodcastsPage/>}/>
                    <Route exact path="/podcasts/the-outer-join" element={<PodcastsPage/>}/>
                    <Route exact path="/podcasts/the-outer-join/page/:pageCount" element={<PodcastsPage/>}/>
                    <Route exact path="/podcasts/page/:pageCount" element={<PodcastsPage/>}/>
                    <Route exact path="/podcasts/:slug" element={<PodcastsDetailPage/>}/>
                </Routes>
            </PageLayout>
        </div>
    )
}

export default App;
